import { useCallback, useMemo, useState } from 'react'

import Document from './document'
import Information from './information'
import Market from './market'
import Transaction from './transaction'

export enum TabsContentPTO {
  DETAILS = 0,
  DOCUMENT = 1,
  TRANSACTION = 2,
  MARKET = 3,
}

const Content = () => {
  const [tab, setTab] = useState(TabsContentPTO.DETAILS)

  const CONTENT_TABS = useMemo(() => {
    return [
      {
        value: TabsContentPTO.DETAILS,
        label: 'Details',
      },
      {
        value: TabsContentPTO.DOCUMENT,
        label: 'Document',
      },
      {
        value: TabsContentPTO.TRANSACTION,
        label: 'Transaction',
      },
      {
        value: TabsContentPTO.MARKET,
        label: 'Market',
      },
    ]
  }, [])

  const renderContent = useCallback(() => {
    switch (tab) {
      case TabsContentPTO.DETAILS:
        return <Information />
      case TabsContentPTO.DOCUMENT:
        return <Document />
      case TabsContentPTO.TRANSACTION:
        return <Transaction />
      case TabsContentPTO.MARKET:
        return <Market />
      default:
        return <div>Details</div>
    }
  }, [tab])

  return (
    <>
      <div className="tab-group">
        {CONTENT_TABS.map((contentTab, index) => {
          return (
            <p
              key={index}
              className={tab === contentTab.value ? 'selected' : ''}
              onClick={() => {
                setTab(contentTab.value)
              }}
            >
              {contentTab.label}
            </p>
          )
        })}
      </div>
      {renderContent()}
    </>
  )
}

export default Content
